// API URL utility function
// This ensures all API calls use the correct base URL based on the current domain

export const getApiUrl = (): string => {
  const currentHost = window.location.hostname;
  
  // Auto-detect environment based on domain
  if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
    return 'http://localhost:5001'; // Local development
  } else if (currentHost.includes('staging.leadforge.me')) {
    return 'https://staging.leadforge.me'; // Staging
  } else if (currentHost.includes('leadforge.me')) {
    return 'https://leadforge.me'; // Production
  }
  
  // Fallback for unknown domains
  return 'https://leadforge.me';
};

// Export a function that can be used as a replacement for process.env.REACT_APP_API_URL
export const getApiUrlForEnv = (): string => {
  return getApiUrl();
};

// Log the API URL being used
const apiUrl = getApiUrl();

export default apiUrl;
